import React, { useState, useEffect } from "react";
import { signInWithEmailAndPassword, getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db, auth } from "../firebase"; // Import Firebase config and auth instance
import { useNavigate } from "react-router-dom";
import "./Login.css"; // Import the CSS file

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Set up the onAuthStateChanged listener
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userRef = doc(db, "users", user.uid);
        try {
          await setDoc(
            userRef,
            {
              email: user.email,
              displayName: user.displayName || "Anonymous User",
              uid: user.uid,
            },
            { merge: true }
          );
        } catch (err) {
          console.error("Error storing user data:", err);
        }
      }
    });

    // Cleanup the listener on component unmount
    return () => unsubscribe();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/patient-list"); // Redirect to TaskList page
    } catch (error) {
      console.error("Error logging in:", error.message);
      setError("Error logging in: " + error.message);
    }
  };

  return (
    <div className="login-container">
      <img src="/logo.png" alt="Logo" className="login-logo" /> {/* Logo at the top */}
      <form onSubmit={handleLogin} className="login-form">
        <input
          type="email"
          placeholder="Username (Email)"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Login</button>
        {error && <p className="login-error">{error}</p>} {/* Error message */}
      </form>
    </div>
  );
}

export default Login;

